<template>
  <button
      :type="btnType"
      class="btn"
      @click="$emit('click', $event)"
  >
    <span v-show="!loading">
      <slot />
    </span>
    <span class="loader" v-if="loading">
      <i class="fa fa-spin fa-spinner"></i>
    </span>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    type: String,
    loading: Boolean
  },
  computed: {
    btnType () {
      return this.type ? this.type : 'button'
    }
  }
}
</script>

<style lang="scss" scoped>
.loader {
  display: inline-block;
}

.hover-color-white:hover, .hover-color-white:focus, .hover-color-white:active {
  ::v-deep {
    .color {
      fill: #fff;
    }
  }
}
.hover-color-color1:hover, .hover-color-color1:focus, .hover-color-color1:active {
  ::v-deep {
    .color {
      fill: $color1;
    }
  }
}

.active {
  ::v-deep {
    .color {
      fill: #fff !important;
    }
  }
}

</style>
